import React, { createContext, useContext, useState, useCallback } from 'react';

const LiveTVMiniPlayerContext = createContext(null);

export const useLiveTVMiniPlayer = () => {
  const context = useContext(LiveTVMiniPlayerContext);
  if (!context) {
    throw new Error('useLiveTVMiniPlayer must be used within a LiveTVMiniPlayerProvider');
  }
  return context;
};

export const LiveTVMiniPlayerProvider = ({ children }) => {
  const [liveChannel, setLiveChannel] = useState(null);
  const [isMinimized, setIsMinimized] = useState(false);
  const [isMuted, setIsMuted] = useState(false);

  // Play a live TV channel (opens in full modal)
  const playChannel = useCallback((channel) => {
    setLiveChannel(channel);
    setIsMinimized(false);
  }, []);

  // Minimize to PiP mode (video keeps playing)
  const minimizePlayer = useCallback(() => {
    setIsMinimized(true);
  }, []);

  // Expand to full modal
  const expandPlayer = useCallback(() => {
    setIsMinimized(false);
  }, []);

  // Close player completely
  const closePlayer = useCallback(() => {
    setLiveChannel(null);
    setIsMinimized(false);
  }, []);

  // Toggle mute
  const toggleMute = useCallback(() => {
    setIsMuted(prev => !prev);
  }, []);

  const value = {
    liveChannel,
    isMinimized,
    isMuted,
    playChannel,
    minimizePlayer,
    expandPlayer,
    closePlayer,
    toggleMute,
    setIsMuted,
  };

  return (
    <LiveTVMiniPlayerContext.Provider value={value}>
      {children}
    </LiveTVMiniPlayerContext.Provider>
  );
};

export default LiveTVMiniPlayerContext;
